<div style="width: 100%;">
  <p class="text-info mb-xlg d-flex justify-content-between align-items-center">
    <span class="truncate">AÑADIR EXCEPCIONES DE FECHAS</span>
    <i *ngIf="!disabled" class="cursor-pointer schedules-exceptions-plus-icon" nz-icon nzType="plus" (click)="onOpenModalNewException()" nzTheme="outline"></i>
  </p>
  <ng-container *ngFor="let exception of exceptions; index as i">
    <div class="exception" @fadeInAnimation>
      <div class="d-flex">
        <span class="text-info mr-md">{{ exception.start.day + '/' + (exception.start.month + 1) + '/' +exception.start.year  }} - {{ exception.end.day + '/' + (exception.end.month + 1) + '/' +exception.end.year }}</span>
        <div class="hours-exceptions" style="min-width: 100px;">
          <p class="text-info" *ngFor="let hour of exception.hourTable; index as j" [class.mb-xs]="j < exception.hourTable.length -1" @fadeInAnimation>
            {{ hour.startHour + ':' + (hour.startMinutes > 9 ? hour.startMinutes : '0' + hour.startMinutes) }} - {{ hour.endHour + ':' + (hour.endMinutes > 9 ? hour.endMinutes : '0' + hour.endMinutes) }}
          </p>
        </div>
      </div>
      <div *ngIf="!disabled" nz-popover="" nzPopoverTitle="" nzPopoverContent="Eliminar" class="icon-action danger" (click)="onRemoveException(i)">
        <i nz-icon nzType="delete" nzTheme="outline"></i>
      </div>
    </div>
    <p class="text-info-sm mt-xxs" *ngIf="exception.recurrent"> Esta excepción se repetirá cada año </p>
    <nz-divider *ngIf="i < exceptions.length -1"></nz-divider>
  </ng-container>
  <p class="text-info align-self-center opacity-30" *ngIf="exceptions.length === 0;">No hay excepciones</p>
</div>
